import Action  from './baseActions';
import {
  IFilter,
  Integration,
  INTEGRATION_LOADING_SOURCE,
  ApiParamsFilter,
  ISort,
} from '../../models';

// Types

export enum IntegrationActionTypes {
  LOAD_INTEGRATION = 'integration/load_integration',
  LOADING_INTEGRATION = 'integration/loading_integration',
  LOADED_INTEGRATION = 'integration/loaded_integration',
  LOADING_INTEGRATION_FAILED = 'integration/loading_integration_failed',
  UNSET_INTEGRATION = 'integration/unset_integration',

  LOAD_INTEGRATIONS = 'integration/load_integrations',
  LOADING_INTEGRATIONS = 'integration/loading_integrations',
  LOADED_INTEGRATIONS = 'integration/loaded_integrations',
  LOADING_INTEGRATIONS_FAILED = 'integration/loading_integrations_failed',
  UNSET_INTEGRATIONS = 'integration/unset_integrations',

  CREATE_INTEGRATION = 'integration/create_integration',
  CREATING_INTEGRATION = 'integration/creating_integration',
  CREATED_INTEGRATION = 'integration/created_integration',
  CREATING_INTEGRATION_FAILED = 'integration/creating_integration_failed',

  UPDATE_INTEGRATION = 'integration/update_integration',
  UPDATING_INTEGRATION = 'integration/updating_integration',
  UPDATED_INTEGRATION = 'integration/updated_integration',
  UPDATING_INTEGRATION_FAILED = 'integration/updating_integration_failed',

  DELETE_INTEGRATION = 'integration/delete_integration',
  DELETING_INTEGRATION = 'integration/deleting_integration',
  DELETED_INTEGRATION = 'integration/deleted_integration',
  DELETING_INTEGRATION_FAILED = 'integration/deleting_integration_failed',

  TEST_INTEGRATION_REQUEST = 'integration/test_integration_request',
  TEST_INTEGRATION_SUCCESS = 'integration/test_integration_success',
  TEST_INTEGRATION_FAILURE = 'integration/test_integration_failure',
}

// Interfaces

export interface ITestIntegrationRequestAction extends Action {
  type: IntegrationActionTypes.TEST_INTEGRATION_REQUEST;
  payload: {
    Integration: Integration;
  }
}

export interface ITestIntegrationSuccessAction extends Action {
  type: IntegrationActionTypes.TEST_INTEGRATION_SUCCESS;
}

export interface ITestIntegrationFailureAction extends Action {
  type: IntegrationActionTypes.TEST_INTEGRATION_FAILURE;
}

export interface ILoadIntegrationAction extends Action {
  type: IntegrationActionTypes.LOAD_INTEGRATION;
  payload: string;
}

export interface ILoadingIntegrationAction extends Action {
  type: IntegrationActionTypes.LOADING_INTEGRATION;
}

export interface ILoadedIntegrationAction extends Action {
  type: IntegrationActionTypes.LOADED_INTEGRATION;
  payload: any;
}

export interface ILoadingIntegrationFailedAction extends Action {
  type: IntegrationActionTypes.LOADING_INTEGRATION_FAILED;
}

export interface IUnsetIntegrationAction extends Action {
  type: IntegrationActionTypes.UNSET_INTEGRATION;
}

export interface ILoadIntegrationsAction extends Action {
  type: IntegrationActionTypes.LOAD_INTEGRATIONS;
  payload: {
    filters?: ApiParamsFilter[] | undefined;
    sort?: ISort;
    reload?: boolean;
    page_size?: number;
    page?: number | undefined;
    source?: INTEGRATION_LOADING_SOURCE;
  };
}

export interface ILoadingIntegrationsAction extends Action {
  type: IntegrationActionTypes.LOADING_INTEGRATIONS;
}

export interface ILoadedIntegrationsAction extends Action {
  type: IntegrationActionTypes.LOADED_INTEGRATIONS;
  payload: any;
}

export interface ILoadingIntegrationsFailedAction extends Action {
  type: IntegrationActionTypes.LOADING_INTEGRATIONS_FAILED;
}

export interface IUnsetIntegrationsAction extends Action {
  type: IntegrationActionTypes.UNSET_INTEGRATIONS;
}

export interface ICreateIntegrationAction extends Action {
  type: IntegrationActionTypes.CREATE_INTEGRATION;
  payload: Partial<Integration>;
}

export interface ICreatingIntegrationAction extends Action {
  type: IntegrationActionTypes.CREATING_INTEGRATION;
}

export interface ICreatedIntegrationAction extends Action {
  type: IntegrationActionTypes.CREATED_INTEGRATION;
  payload: {
    result: any
  };
}

export interface ICreatingIntegrationFailedAction extends Action {
  type: IntegrationActionTypes.CREATING_INTEGRATION_FAILED;
}

export interface IUpdateIntegrationAction extends Action {
  type: IntegrationActionTypes.UPDATE_INTEGRATION;
  payload: Integration;
}

export interface IUpdatingIntegrationAction extends Action {
  type: IntegrationActionTypes.UPDATING_INTEGRATION;
}

export interface IUpdatedIntegrationAction extends Action {
  type: IntegrationActionTypes.UPDATED_INTEGRATION;
  payload: any;
}

export interface IUpdatingIntegrationFailedAction extends Action {
  type: IntegrationActionTypes.UPDATING_INTEGRATION_FAILED;
}

export interface IDeleteIntegrationAction extends Action {
  type: IntegrationActionTypes.DELETE_INTEGRATION;
  payload: string;
}

export interface IDeletingIntegrationAction extends Action {
  type: IntegrationActionTypes.DELETING_INTEGRATION;
}

export interface IDeletedIntegrationAction extends Action {
  type: IntegrationActionTypes.DELETED_INTEGRATION;
  payload: string;
}

export interface IDeletingIntegrationFailedAction extends Action {
  type: IntegrationActionTypes.DELETING_INTEGRATION_FAILED;
}

// Functions

export function testIntegrationRequest(Integration: Integration): ITestIntegrationRequestAction {
  return {
    type: IntegrationActionTypes.TEST_INTEGRATION_REQUEST,
    payload: {
      Integration
    }
  };
}

export function testIntegrationSuccess(): ITestIntegrationSuccessAction {
  return {
    type: IntegrationActionTypes.TEST_INTEGRATION_SUCCESS,
  };
}

export function testIntegrationFailure(): ITestIntegrationFailureAction {
  return {
    type: IntegrationActionTypes.TEST_INTEGRATION_FAILURE,
  };
}

export function loadIntegration(uid: string): ILoadIntegrationAction {
  return {
    type: IntegrationActionTypes.LOAD_INTEGRATION,
    payload: uid,
  };
}

export function loadingIntegration(): ILoadingIntegrationAction {
  return {
    type: IntegrationActionTypes.LOADING_INTEGRATION,
  };
}

export function loadedIntegration(data: any): ILoadedIntegrationAction {
  return {
    type: IntegrationActionTypes.LOADED_INTEGRATION,
    payload: data,
  };
}

export function loadingIntegrationFailed(): ILoadingIntegrationFailedAction {
  return {
    type: IntegrationActionTypes.LOADING_INTEGRATION_FAILED,
  };
}

export function unsetIntegration(): IUnsetIntegrationAction {
  return {
    type: IntegrationActionTypes.UNSET_INTEGRATION,
  };
}

export function loadIntegrations({filters, sort, page_size, page, reload, source}: {
  filters?: IFilter[];
  sort?: ISort;
  page_size?: number;
  page?: number;
  reload?: boolean;
  source?: INTEGRATION_LOADING_SOURCE;
}): ILoadIntegrationsAction {
  return {
    type: IntegrationActionTypes.LOAD_INTEGRATIONS,
    payload: {
      filters: filters ?
        filters
          .reduce((acc: ApiParamsFilter[], {name, opr, value}: IFilter) => {
            if (name && opr && value) {
              acc.push({
                col: name,
                opr, value
              });
            }
            return acc;
          }, [] as ApiParamsFilter[]) :
        undefined,
      sort,
      reload,
      page_size,
      page,
      source,
    }
  };
}

export function loadingIntegrations(): ILoadingIntegrationsAction {
  return {
    type: IntegrationActionTypes.LOADING_INTEGRATIONS,
  };
}

export function loadedIntegrations(result: any, reload: boolean = false, page_size: number = 0): ILoadedIntegrationsAction {
  return {
    type: IntegrationActionTypes.LOADED_INTEGRATIONS,
    payload: {
      result,
      reload,
      page_size
    },
  };
}

export function loadingIntegrationsFailed(): ILoadingIntegrationsFailedAction {
  return {
    type: IntegrationActionTypes.LOADING_INTEGRATIONS_FAILED,
  };
}

export function unsetIntegrations(): IUnsetIntegrationsAction {
  return {
    type: IntegrationActionTypes.UNSET_INTEGRATIONS,
  };
}

export function createIntegration(integration: Partial<Integration>): ICreateIntegrationAction {
  return {
    type: IntegrationActionTypes.CREATE_INTEGRATION,
    payload: integration,
  };
}

export function creatingIntegration(): ICreatingIntegrationAction {
  return {
    type: IntegrationActionTypes.CREATING_INTEGRATION,
  };
}

export function createdIntegration(data: any): ICreatedIntegrationAction {
  return {
    type: IntegrationActionTypes.CREATED_INTEGRATION,
    payload: {
      result: data,
    },
  };
}

export function creatingIntegrationFailed(): ICreatingIntegrationFailedAction {
  return {
    type: IntegrationActionTypes.CREATING_INTEGRATION_FAILED,
  };
}

export function updateIntegration(integration: Integration): IUpdateIntegrationAction {
  return {
    type: IntegrationActionTypes.UPDATE_INTEGRATION,
    payload: integration,
  };
}

export function updatingIntegration(): IUpdatingIntegrationAction {
  return {
    type: IntegrationActionTypes.UPDATING_INTEGRATION,
  };
}

export function updatedIntegration(data: any): IUpdatedIntegrationAction {
  return {
    type: IntegrationActionTypes.UPDATED_INTEGRATION,
    payload: data,
  };
}

export function updatingIntegrationFailed(): IUpdatingIntegrationFailedAction {
  return {
    type: IntegrationActionTypes.UPDATING_INTEGRATION_FAILED,
  };
}

export function deleteIntegration(uid: string): IDeleteIntegrationAction {
  return {
    type: IntegrationActionTypes.DELETE_INTEGRATION,
    payload: uid,
  };
}

export function deletingIntegration(): IDeletingIntegrationAction {
  return {
    type: IntegrationActionTypes.DELETING_INTEGRATION,
  };
}

export function deletedIntegration(uid: string): IDeletedIntegrationAction {
  return {
    type: IntegrationActionTypes.DELETED_INTEGRATION,
    payload: uid,
  };
}

export function deletingIntegrationFailed(): IDeletingIntegrationFailedAction {
  return {
    type: IntegrationActionTypes.DELETING_INTEGRATION_FAILED,
  };
}

export type IntegrationActions =
  | ILoadIntegrationAction
  | ILoadingIntegrationAction
  | ILoadedIntegrationAction
  | ILoadingIntegrationFailedAction
  | IUnsetIntegrationAction
  | ILoadIntegrationsAction
  | ILoadingIntegrationsAction
  | ILoadedIntegrationsAction
  | ILoadingIntegrationsFailedAction
  | IUnsetIntegrationsAction
  | ICreateIntegrationAction
  | ICreatingIntegrationAction
  | ICreatedIntegrationAction
  | ICreatingIntegrationFailedAction
  | IUpdateIntegrationAction
  | IUpdatingIntegrationAction
  | IUpdatedIntegrationAction
  | IUpdatingIntegrationFailedAction
  | IDeleteIntegrationAction
  | IDeletingIntegrationAction
  | IDeletedIntegrationAction
  | IDeletingIntegrationFailedAction
  | ITestIntegrationRequestAction
  | ITestIntegrationSuccessAction
  | ITestIntegrationFailureAction;
